import React from 'react';
import { styled } from '@mui/system';
import { Typography } from '@mui/material';

const MOBILE_BREAK_POINT = 768;

const Wrapper = styled('div')(({ theme }) => ({
	width: '100%',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	backgroundImage: "url('/landing/partners-bg.png')",
	backgroundSize: 'cover',
	backgroundPosition: 'top',
	padding: '0 60px 0 30px',
	borderTop: `1px solid ${theme.palette.atlas.border.neutral}`,
}));

const LogoWrapper = styled('div')`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	height: 100%;

	@media (max-width: ${MOBILE_BREAK_POINT}px) {
		padding: 0 16px;
	}
`;

const Footer = () => {
	return (
		<Wrapper>
			<LogoWrapper>
				<img
					src={'/images/loading.png'}
					height={20}
					width={96}
					alt={'rndm'}
				/>
			</LogoWrapper>
			<Typography color="textPrimary" variant="caption">
				©{new Date().getFullYear()} RNDM. All rights reserved.
			</Typography>
		</Wrapper>
	);
};

export default Footer;
